import type { AxiosError, AxiosResponse } from 'axios';
import axios, { AxiosRequestConfig } from 'axios';
import {
  AXIOS_INSTANCE,
  AxiosCustomOptions,
  customClientException,
} from './custom-instance';

type CustomClient<T> = (
  data: AxiosRequestConfig,
  options?: Omit<AxiosCustomOptions, 'headers'>
) => Promise<AxiosResponse<T>>;

export const useS3Client = <T>(): CustomClient<T> => {
  return async (config: AxiosRequestConfig, options?: AxiosCustomOptions) => {
    config.timeout = options?.timeout;
    const source = axios.CancelToken.source();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const promise = AXIOS_INSTANCE<any, AxiosResponse<T>>({
      ...config,
      cancelToken: source.token,
    }).catch((err: AxiosError<T>) => {
      return customClientException(err, config, options);
    });
    // @ts-ignore
    promise.cancel = () => {
      source.cancel('Query was cancelled by React Query');
    };
    return promise;
  };
};

// eslint-disable-next-line import/no-default-export
export default useS3Client;

export type ErrorType<ErrorData> = ErrorData;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type BodyType<BodyData> = BodyData & { headers?: any };
